/**
 * @file_purpose  page created for provider details page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 07-03-2024
 */

import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom';
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { listGame, resetListGame } from '../../redux/slices/GameSlice';
import { FormattedMessage } from "react-intl";
import { toast } from 'react-toastify';

const ProviderDetails = () => {

    const dispatch = useDispatch();

    const location = useLocation();
    let provider_id = location.state.provider_id;
    let provider_name = location.state.provider_name;

    let gameState = useSelector((state) => state.gameState);
    const userDetailState = useSelector((state) => state.userDetailState);
    const languageState = useSelector((state) => state.languageState);
    // let token = userDetailState?.user_details?.token ? userDetailState?.user_details?.token : ""
    let languageCode = languageState.active_language.language_code;
    let [loading, setLoading] = useState(true);

    let newPage = 1;
    let [page, setPage] = useState(1);
    let [limit, setLimit] = useState(20);
    let [totalPage, setTotalPage] = useState(1);

    console.log(totalPage, page);

    const [state, setState] = useState({
        game_name: "",
        is_popular: ""
    })

    useEffect(() => {
        // if (location.pathname != currentRoute) {
        dispatch(resetListGame())
        // }
    }, [location.pathname])

    /**
* @author Swarnali Ghosh
* @Date_Created 07-03-2024
* @Date_Modified 07/03/2023
* @function async
* @functionName loadGameList
* @functionPurpose this function gets game list provider wise.
* @functionParam {}
* @functionSuccess Success status and message.
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/

    async function loadGameList() {

        let params = JSON.stringify({
            "provider_id": provider_id,
            "game_name": state.game_name,
            "category_id": "",
        })

        GeneralService.apiPostCallRequest(`${ApiURL.getGameList}?page=${newPage}&limit=${limit}`, params, userDetailState.user_details.token).then(res => {

            if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
                setLoading(false)
                setTotalPage(res.data.pages)
                dispatch(listGame(res.data.games))
            }

        }).catch(error => {
            setLoading(false)
        })

    }


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    //     setPage(1)
    //     dispatch(resetListGame())
    //     loadGameList();

    // }, [provider_id, state.game_name])

    const handleChange = (e) => {
        const { id, value } = e.target;
        setLoading(true)
        setState(prevState => ({
            ...prevState,
            [id]: value
        }))
    }

    const loadMoreClick = () => {
        newPage = page + 1;
        setPage(newPage);
        loadGameList();
    }

    // const gameLunchHandler = (game_code) => {

    //     let params = JSON.stringify({
    //         "game_code": game_code,
    //         "language": languageCode
    //     })

    //     if (!token) {
    //         toast.error("Login to play!", {
    //             position: "bottom-right",
    //         })
    //     } else {
    //         GeneralService.apiPostCallRequest(ApiURL.getGameURL, params, token).then(res => {

    //             window.open(`${res.data.url}`, "_blank", "noreferrer");

    //         }).catch(error => {
    //             console.log(error);
    //         })
    //     }

    // }

    return (
        <div className='container' >
            <div className='provider-heading-section'>

                <span>{provider_name[languageCode]}</span>
                <Link to="/"><button className='back-button'>
                    <i class="fa-solid fa-arrow-left me-2"></i> <FormattedMessage id='BACK' />
                </button></Link>

            </div>
            <div className='provider-detail-page-section'>
                <div className='search_filter_section'>
                    <div className='provider-filter-section'>
                        <Link to="/provider-list">
                            <button className='view-all-providers' style={{ marginRight: "10px" }}>
                                <FormattedMessage id='VIEWALLPROVIDERS' />
                            </button>
                        </Link>
                    </div>
                    <div className="game_search_sec">
                        <i className="fa-solid fa-magnifying-glass" />
                        <input type="search" id='game_name' name='game_name' placeholder={languageCode == "en" ? "Search your game" : "게임 검색"} value={state.game_name} onChange={handleChange} />
                    </div>


                </div>

                <div className='povider-game-list-section'>
                    <div className='row w-100 d-flex align-items-center justify-content-center'>
                        {loading ?
                            <div className="spinner-border text-primary" role="status" style={{ marginTop: "20px" }}>
                                <span className="visually-hidden"></span>
                            </div> : ""
                        }
                    </div>
                    {gameState?.game_list?.length > 0 ? gameState?.game_list.map((gameData, gameIndex) => (
                        <div className='col-2' 
                        // onClick={() => gameLunchHandler(gameData.game_code)}
                        >
                            <div className='each-game-card'>
                                <img className='each-game-card-img w-100' src={gameData.image_file_name} alt="true" />
                                <div className='game-detail-section'>

                                    <span className='game-detail-playing'>{gameData.game_name[languageCode]}</span>
                                    <span className='game-provider-name'>{gameData.provider_name[languageCode]}</span>
                                </div>
                            </div>
                        </div>
                    )) :
                        ""
                    }

                    {
                        (loading == false && gameState?.game_list?.length == 0) ?
                            <div className="alert alert-primary no_game_found" role="alert">
                                <FormattedMessage id='NOGAMEFOUND' />
                            </div> : ""
                    }


                </div>
                {(totalPage == page) ? "" :
                    <div className='load_more_button_div'>
                        <button className='load_more_button' onClick={loadMoreClick}
                            hidden={totalPage == 0 ? true : false}>
                            <FormattedMessage id='LOADMORE' />
                        </button>
                    </div>}


            </div>
        </div>
    )
}

export default ProviderDetails